<div class="flex items-center justify-center m-auto bottom-0">
    <p class="copy text-center text-black pl-10 dark:text-white bottom-0 animate__animated animate__backInDown animate__delay-1s">
      &copy; 2024 PITZON. {{ 'HOME.FOOTER' | translate }}
    </p>
  </div>